// @ts-nocheck
import React, { useState } from "react";
import useFetch from "../../../ApiClient/GetApi";
import MessageBar from "../../messageBar/MessageBar";
import Header from "../layout/Header";
import CompletedOrder from "./myOrdersSections/CompletedOrder";
import AllOrders from "./myOrdersSections/AllOrders";
import IncompleteOrder from "./myOrdersSections/IncompleteOrder";
import PendingOrder from "./myOrdersSections/PendingOrder";

export default function MyOrders() {
  const [tabs, setTabs] = useState("all");
  const [companyId, setCompanyId] = useState("");

  const all = () => {
    setTabs("all");
  };
  const created = () => {
    setTabs("created");
  };
  const incomplete = () => {
    setTabs("incomplete");
  };
  const pending = () => {
    setTabs("pending");
  };
  const completed = () => {
    setTabs("completed");
  };

  const on_select = (value) => {
    setTabs(value);
  };

  const company_select = (companyId) => {
    if (companyId === "0") {
      setCompanyId("");
    } else {
      setCompanyId(companyId);
    }
  };
  const inputStyle =
    "border-none bg-white rounded p-3 placeholder:text-black placeholder:text-opacity-40 font-normal text-base focus:ring-0 w-full";
  const buttonStyle =
    "py-2 px-4 sm:rounded-md font-medium text-xl border border-themeBlue sm:w-full w-full";

  const { data } = useFetch("users/home/my_orders");
  const companies = useFetch("booking/get_all_companies");
  return (
    <section className="font-soehne">
      <Header />
      <section
        className="xl:w-4/5 w-11/12 bg-themeGray2 mx-auto lg:my-20 my-12 sm:py-10 py-6 sm:px-8 px-4 
        rounded-lg space-y-8"
      >
        <div className="flex items-center gap-x-4">
          <div className="w-12 h-12 bg-white rounded-fullest flex justify-center items-center">
            <img src="images/sendParcel/box.webp" alt="box" className="w-6" />
          </div>
          <h1 className="font-medium text-2xl text-themeBlue">My Orders</h1>
        </div>
        <div className="grid md:grid-cols-3 sm:grid-cols-2 items-end gap-x-5 gap-y-4">
          <div className="space-y-2 md:order-1 order-1">
            <label htmlFor="shipment_status" className="font-normal text-base">
              Select Category
            </label>
            <select
              onChange={(e) => on_select(e.target.value)}
              name="shipment_status"
              id="shipment_status"
              className={inputStyle}
            >
              <option value="all">All Orders</option>
              <option value="created">Created</option>
              <option value="incomplete">Incomplete</option>
              <option value="pending">Waiting Payment</option>
              <option value="completed">Complete</option>
            </select>
          </div>
          {/* <div className="md:order-2 order-3">
            <input
              type="search"
              name="order_no"
              placeholder="Search by order number..."
              className={inputStyle}
            />
          </div> */}
          <div className="space-y-2 md:order-3 order-2">
            <label htmlFor="supplier" className="font-normal text-base">
              Supplier
            </label>
            <select
              onChange={(e) => company_select(e.target.value)}
              name="supplier"
              id="supplier"
              className={inputStyle}
            >
              <option value="0">Select Company</option>
              {companies?.data?.data?.map((comapny) => (
                <option value={comapny.id}>{comapny.name}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="flex sm:flex-row flex-col items-center gap-x-2">
          <button
            className={`${buttonStyle} ${
              tabs === "all"
                ? "bg-themeBlue text-white"
                : "bg-transparent text-themeBlue"
            }`}
            onClick={all}
          >
            All Orders
          </button>
          <button
            className={`${buttonStyle} ${
              tabs === "created"
                ? "bg-themeBlue text-white"
                : "bg-transparent text-themeBlue"
            }`}
            onClick={created}
          >
            Created
          </button>

          <button
            className={`${buttonStyle} ${
              tabs === "pending"
                ? "bg-themeBlue text-white"
                : "bg-transparent text-themeBlue"
            }`}
            onClick={pending}
          >
            Waiting Payment
          </button>
          <button
            className={`${buttonStyle} ${
              tabs === "completed"
                ? "bg-themeBlue text-white"
                : "bg-transparent text-themeBlue"
            }`}
            onClick={completed}
          >
            Completed
          </button>
          <button
            className={`${buttonStyle} ${
              tabs === "incomplete"
                ? "bg-themeBlue text-white"
                : "bg-transparent text-themeBlue"
            }`}
            onClick={incomplete}
          >
            Incomplete
          </button>
        </div>
        {tabs === "incomplete" ? (
          <>
            <div className="grid lg:grid-cols-2 gap-x-5 gap-y-8">
              {data?.data?.incomplete?.length > 0 ? (
                <>
                  {companyId === "" ? (
                    <>
                      {data?.data?.incomplete?.map((order) => (
                        <IncompleteOrder
                          orderNo={order.id}
                          button="Cancel Order"
                          steps={
                            order.location === "/company_details"
                              ? "5"
                              : order.location === "/supplier_details"
                              ? "4"
                              : order.location === "/consignee_details"
                              ? "3"
                              : order.location === "destination_details"
                              ? "2"
                              : order.location === "/order_summary"
                              ? "1"
                              : ""
                          }
                          time={order.startDate}
                          reviews={order.Comments.length}
                          button2={order.location}
                        />
                      ))}
                    </>
                  ) : (
                    <>
                      {data?.data?.incomplete?.map((order) =>
                        companyId == order.CompanyId ? (
                          <>
                            <IncompleteOrder
                              orderNo={order.id}
                              button="Cancel Order"
                              steps="3"
                              time={order.startDate}
                              reviews={order.Comments.length}
                              button2={order.location}
                            />
                          </>
                        ) : (
                          <></>
                        )
                      )}
                    </>
                  )}
                </>
              ) : (
                <p>Sorry! No Order in this category.</p>
              )}
            </div>
            <MessageBar
              background="bg-themeYellowLight"
              border="border-themeYellow"
              imgback="bg-themeYellow"
              image="warning"
              text="Incomplete order will be removed after 7 days"
            />
          </>
        ) : tabs === "pending" ? (
          <>
            <div className="grid lg:grid-cols-2 gap-x-5 gap-y-8">
              {data?.data?.pending?.length > 0 ? (
                <>
                  {companyId === "" ? (
                    <>
                      {data?.data?.pending?.map((order) => (
                        <PendingOrder
                          orderNo={order.id}
                          button="Waybill Details"
                          steps="3"
                          time={order.startDate}
                          button2="Complete Order"
                        />
                      ))}
                    </>
                  ) : (
                    <>
                      {data?.data?.pending?.map((order) =>
                        companyId == order.CompanyId ? (
                          <>
                            <PendingOrder
                              orderNo={order.id}
                              button="Waybill Details"
                              steps="3"
                              time={order.startDate}
                              button2="Complete Order"
                            />
                          </>
                        ) : (
                          <></>
                        )
                      )}
                    </>
                  )}
                </>
              ) : (
                <p>Sorry! No Order in this category.</p>
              )}
            </div>
            <MessageBar
              background="bg-themeBlue7"
              border="border-themeBlue2"
              imgback="bg-themeBlue2"
              image="info"
              text="Complete your payment to proceed with the order"
            />
          </>
        ) : tabs === "completed" ? (
          <div className="grid lg:grid-cols-3 sm:grid-cols-2 gap-x-5 gap-y-8">
            {data?.data?.completed?.length > 0 ? (
              <>
                {companyId === "" ? (
                  <>
                    {data?.data?.completed?.map((order) => (
                      <CompletedOrder
                        orderNo={order.id}
                        time={order.deliveredDateTime}
                        bookingStatus={order.bookingStatus}
                        confirmTotalPrice={order.confirmTotalPrice}
                        serviceType={order.serviceType}
                        totalPackages={order.Packages.length ?? "0.0"}
                        totalProducts={order.Products.length ?? "0.0"}
                      />
                    ))}
                  </>
                ) : (
                  <>
                    {data?.data?.completed?.map((order) =>
                      companyId == order.CompanyId ? (
                        <>
                          <CompletedOrder
                            orderNo={order.id}
                            time={order.endDate}
                            bookingStatus={order.bookingStatus}
                            serviceType={order.serviceType}
                            totalPackages={order.Packages.length ?? "0.0"}
                            totalProducts={order.Products.length ?? "0.0"}
                          />
                        </>
                      ) : (
                        <></>
                      )
                    )}
                  </>
                )}
              </>
            ) : (
              <p>Sorry! No Order in this category.</p>
            )}
          </div>
        ) : tabs === "created" ? (
          <>
            <div className="grid lg:grid-cols-2 gap-x-5 gap-y-8">
              {data?.data?.created?.length > 0 ? (
                <>
                  {companyId === "" ? (
                    <>
                      {data?.data?.created?.map((order) => (
                        <AllOrders
                          orderNo={order.id}
                          time={order.startDate}
                          bookingStatus={order.bookingStatus}
                          verification={order.verification}
                        />
                      ))}
                    </>
                  ) : (
                    <>
                      {data?.data?.created?.map((order) =>
                        companyId == order.CompanyId ? (
                          <>
                            <AllOrders
                              orderNo={order.id}
                              time={order.startDate}
                              bookingStatus={order.bookingStatus}
                              verification={order.verification}
                            />
                          </>
                        ) : (
                          <></>
                        )
                      )}
                    </>
                  )}
                </>
              ) : (
                <p>Sorry! No Order in this category.</p>
              )}
            </div>
            <MessageBar
              background="bg-themeYellowLight"
              border="border-themeYellow"
              imgback="bg-themeYellow"
              image="warning"
              text="Incomplete order will be removed after 7 days"
            />
          </>
        ) : (
          <div className="grid lg:grid-cols-3 sm:grid-cols-2 gap-x-5 gap-y-8">
            {data?.data?.all?.length > 0 ? (
              <>
                {companyId === "" ? (
                  <>
                    {data?.data?.all?.map((order) => (
                      <AllOrders
                        orderNo={order.id}
                        time={order.startDate}
                        bookingStatus={order.bookingStatus}
                        verification={order.verification}
                      />
                    ))}
                  </>
                ) : (
                  <>
                    {data?.data?.all?.map((order) =>
                      companyId == order.CompanyId ? (
                        <>
                          <AllOrders
                            orderNo={order.id}
                            time={order.startDate}
                            bookingStatus={order.bookingStatus}
                            verification={order.verification}
                          />
                        </>
                      ) : (
                        <></>
                      )
                    )}
                  </>
                )}
              </>
            ) : (
              <p>Sorry! No Order in this category.</p>
            )}
          </div>
        )}
      </section>
    </section>
  );
}
